(function() {
'use strict';

angular
    .module('TR')
    .service('savedSearchService', savedSearchService);

function savedSearchService(hotelSearchValidator,
                            $http,
                            searchUnitService,
                            dateUtil,
                            occupancyService,
                            resourceService,
                            arrayUtil,
                            $q,
                            $routeParams,
                            broker,
                            $rootScope,
                            analytics,
                            searchTypesService,
                            tripService,
                            unadjustedDateFilter) {
    const url = '/api2/savedsearches/';
    const isPrerender = /prerender/i.test(navigator.userAgent);

    // cached results
    let cachedSearches;
    let cachedSearchTypes = [];

    const searchType = searchTypesService.searchType;
    const supportedSearchTypes = searchTypesService.supportedTypes();

    const title = {
        1: resourceService.getDeferred('FLIGHTS'),
        3: resourceService.getDeferred('HOLIDAYS'),
        2: resourceService.getDeferred('HOTELS'),
        4: resourceService.getDeferred('TRANSFERS'),
        6: resourceService.getDeferred('AIRPORTPARKING'),
        8: resourceService.getDeferred('INSURANCE')
    };
    const fromDateTitle = {
        1: resourceService.getDeferred('DEPART'),
        2: resourceService.getDeferred('CHECKIN'),
        3: resourceService.getDeferred('DEPART'),
        4: resourceService.getDeferred('ARRIVAL'),
        6: resourceService.getDeferred('DROPOFFDATE'),
        8: resourceService.getDeferred('DEPART')
    };
    const toDateTitle = {
        1: resourceService.getDeferred('RETURN'),
        2: resourceService.getDeferred('CHECKOUT'),
        3: resourceService.getDeferred('RETURN'),
        4: resourceService.getDeferred('RETURN'),
        6: resourceService.getDeferred('PICKUPDATE'),
        8: resourceService.getDeferred('RETURN')
    };
    const fromDateField = {
        1: 'DepartureDate',
        2: 'CheckInDate',
        3: 'DepartureDate',
        4: 'ArrivalDate',
        6: 'DepartureDate',
        8: 'DepartureDate'
    };
    const toDateField = {
        1: 'ReturnDate',
        2: 'CheckOutDate',
        3: 'ReturnDate',
        4: 'ReturnDate',
        6: 'ReturnDate',
        8: 'ReturnDate'
    };
    const cabin = {
        1: 'Economy',
        2: 'PremiumEconomy',
        4: 'First',
        8: 'Business'
    };

    $rootScope.$on('auth:signin', function() {
        cachedSearches = null;
    });
    $rootScope.$on('auth:signout', function() {
        cachedSearches = null;
    });

    const service = {
        saveFlightSearch,
        saveHolidaySearch,
        saveHotelSearch,
        saveTransferSearch,
        saveParkingSearch,
        saveInsuranceSearch,
        restoreSearch,
        getSavedSearches,
        removeSavedSearch,
        getCabinType
    };

    function _getFlightSearch(tripId, SearchModel) {
        return $q.all([
            tripService.getTripDestination(tripId),
            tripService.getSelectedDepartureAirport(tripId),
            tripService.getSelectedDestinationAirport(tripId),
            tripService.isOneWayFlightEnabled(tripId),
            tripService.getFlightsRequestDepartureDate(tripId, true),
            tripService.getFlightsRequestReturnDate(tripId, true),
            tripService.getTripReducedOccupancy(tripId)
        ]).then(([
            Destination,
            DepartureAirport,
            DestinationAirport,
            isOneWayFlightEnabled,
            DepartureDate,
            ReturnDate,
            ReducedOccupancy
        ]) => {
            const flightSearchRequest = {
                DepartureAirportTitle: DepartureAirport.Title,
                Destination,
                DestinationAirportTitle: DestinationAirport.Title,
                DepartureDate,
                SearchModel
            };
            if (DepartureAirport.Code) {
                flightSearchRequest.DepartureAirports = DepartureAirport.Code.split(',');
            }
            // This is a a hacky fix. DestinationAirport can be in two different shapes
            // due to undetermined circumstances (probably search unit configuration)
            let destinationCodes = DestinationAirport.Code ? DestinationAirport.Code : DestinationAirport.DestinationAirports;
            if (destinationCodes) {
                flightSearchRequest.DestinationAirports = destinationCodes.split(',');
            }
            if (isOneWayFlightEnabled) {
                flightSearchRequest.OneWayOnly = true;
            } else {
                flightSearchRequest.ReturnDate = ReturnDate;
            }

            angular.extend(flightSearchRequest, ReducedOccupancy);
            flightSearchRequest.Children = flightSearchRequest.ChildAges.length;

            return flightSearchRequest;
        });
    }

    function _getHolidaySearch(tripId, searchModel) {
        return $q.all([
            tripService.getTripDestination(tripId),
            tripService.getSelectedDepartureAirport(tripId),
            tripService.getFlightsRequestDepartureDate(tripId, true),
            tripService.getFlightsRequestReturnDate(tripId, true),
            tripService.getTripOccupancy(tripId),
            tripService.getFlightCabin(tripId)
        ]).then(results => {
            const values = results.every(result => {
               return result !== null;
            });
            return values ?
            $q.resolve({
                Destination: results[0],
                DepartureAirports: results[1].Code.split(','),
                DepartureAirportsTitle: results[1].Title,
                DepartureDate: results[2],
                ReturnDate: results[3],
                Rooms: results[4],
                Cabin: results[5],
                SearchModel: searchModel
            }) : $q.reject();
        });
    }

    function _getHotelSearch(tripId) {
        return $q.all([
            tripService.getTripDestination(tripId),
            tripService.getHotelsRequestCheckInDate(tripId, true),
            tripService.getHotelsRequestCheckOutDate(tripId, true),
            tripService.getTripOccupancy(tripId)
        ]).then(results => ({
            Destination: results[0],
            CheckInDate: results[1],
            CheckOutDate: results[2],
            Rooms: results[3]
        }));
    }

    function _getTransferSearch() {
        const airport = searchUnitService.getDestinationAirport();
        const route = searchUnitService.getRoute();
        const occ = occupancyService.reduceOccupancy();
        return {
            Airport: airport.Code,
            AirportTitle: airport.Title,
            Route: route,
            Direction: searchUnitService.getDirection(),
            ArrivalDate: searchUnitService.requiresStartDate() ? searchUnitService.startDate(searchUnitService.transfer) : null,
            ReturnDate: searchUnitService.requiresEndDate() ? searchUnitService.endDate(searchUnitService.transfer) : null,
            Passengers: {
                Adults: occ.Adults,
                ChildAges: occ.ChildAges
            }
        };
    }

    function _getInsuranceSearch() {
        const occ = occupancyService.reduceOccupancy();
        const policyType = searchUnitService.getPolicyType();
        const destination = searchUnitService.getTravelDestination();
        return {
            StartDate: searchUnitService.requiresStartDate() ? searchUnitService.startDate(searchUnitService.insurance) : null,
            EndDate: searchUnitService.requiresEndDate() ? searchUnitService.endDate(searchUnitService.insurance) : null,
            AdultAges: occ.AdultAges,
            ChildAges: occ.ChildAges,
            PolicyExtras: searchUnitService.getPolicyExtra(),
            PolicyType: policyType.Id,
            PolicyTypeTitle: policyType.Name,
            Destination: destination.Id,
            DestinationTitle: destination.Name
        };
    }

    function _getParkingSearch(tripId) {
        return $q.all([
            tripService.getParkingAirport(tripId),
            tripService.getParkingDropOffDate(tripId),
            tripService.getParkingPickUpDate(tripId),
            tripService.getTripOccupancy(tripId)
        ]).then(results => ({
            AirportCode: results[0].Code,
            AirportTitle: results[0].Title,
            DropOffDate: results[1],
            PickUpDate: results[2],
            Passengers: results[3]
        }));
    }

    function _normaliseSearch(s) {
        const dateTimeFormat = 'dd MMM yyyy HH:mm';

        s.TypeTitle = title[s.SearchType]();
        window.dataLayer = window.dataLayer || [];
        switch (s.SearchType) {
            case searchType.Flight:
                s.Duration = s.OneWayOnly ? null : dateUtil.getDurationSummary(s.DepartureDate, s.ReturnDate);
                // If Destination is not there then we fill in what we can and then basket service will take them
                // to the non-flexible flight workflow. If it has something then basket service will take them to a flexible
                // flight workflow
                if (!s.Destination) {
                    s.Destination = { Title: s.DestinationAirportTitle };
                }
                window.dataLayer.push({ CabinTitle: cabin[s.Cabin] });
                break;
            case searchType.Hotels:
                s.Duration = dateUtil.getDurationSummary(s.CheckInDate, s.CheckOutDate);
                break;
            case searchType.Holidays:
                s.Duration = dateUtil.getDurationSummary(s.DepartureDate, s.ReturnDate);
                window.dataLayer.push({ CabinTitle: cabin[s.Cabin] });
                break;
            case searchType.Transfers: {
                let str = s.ArrivalDate != null ? dateUtil.format(s.ArrivalDate, dateTimeFormat) : '';
                str += s.ArrivalDate != null && s.ReturnDate != null ? ' - ' : '';
                str += s.ReturnDate != null ? dateUtil.format(s.ReturnDate, dateTimeFormat) : '';
                s.Duration = str;
                s.Destination = { Title: _.get(s, 'ResortTitle') || _.get(s, 'Route.DropOffPoint.Description') };
                break;
            }
            case searchType.Parking:
                s.Destination = { Title: s.AirportTitle };
                s.Duration = `${unadjustedDateFilter(s.DropOffDate, dateTimeFormat)} - ${unadjustedDateFilter(s.PickUpDate, dateTimeFormat)}`;
                break;
            case searchType.Insurance:
                s.Duration = dateUtil.getDurationSummary(s.StartDate, s.EndDate);
        }

        // provide generic "from" and "to" dates that can be rendered by a single template
        s.FromDate = { Date: s[fromDateField[s.SearchType]], Title: fromDateTitle[s.SearchType] };
        s.ToDate = s.OneWayOnly ? null : { Date: s[toDateField[s.SearchType]], Title: toDateTitle[s.SearchType] };

        s.Nights = s.OneWayOnly ? null : dateUtil.numberOfNights(s.FromDate.Date, s.ToDate.Date);

        // sum occupancy
        if (s.Rooms) {
            const occ = _.reduce(s.Rooms, (sum, value) => {
                return {
                    Adults: sum.Adults + value.Adults,
                    ChildAges: (sum.ChildAges || []).concat(value.ChildAges || [])
                };
            });
            s.Adults = occ.Adults;
            s.Children = (occ.ChildAges || []).length;
        }

        delete s.SearchModel;

        return s;
    }

    function _saveSearch(type, op, getter) {
        let s = getter();
        s.SearchType = type;
        const searchModel = s.SearchModel;
        s = _normaliseSearch(s);

        if (TRPCONFIG.EnableSavedSearches) {
            cachedSearches = null;
            $http.post(url + op, s, { ignoreErrors: true }).then(function(res) {
                s.SavedSearchId = res.data;
                broker.publish('savedSearchAdded', s);
            });
        }
        let trackSearchEvent = { category: 'searches', action: 'run', label: op.replace('save', '') };
        if (TRPCONFIG.Domain.TenantId === 3) {
            trackSearchEvent.dimension3 = searchModel.airports.map(elem => { return elem.Code; }).join(',');
            trackSearchEvent.dimension4 = searchModel.destination[0].DestinationAirports;
            trackSearchEvent.dimension5 = searchModel.startDate;
            trackSearchEvent.dimension6 = searchModel.endDate;
            trackSearchEvent.dimension7 = occupancyService.getOccupancyString(searchModel.occupancy);
            trackSearchEvent.dimension8 = searchModel.cabin;
        }

        let IsAmend = $routeParams.bookingId ? true : undefined;

        analytics.track('mixpanel', 'Search', _.extend({}, s, { searchModel, IsAmend }));
        analytics.track('Search', type, s);
        analytics.trackEvent(trackSearchEvent);
        analytics.track('mixpanelPeople', 'Search', s);
    }

    function _searchRestored() {
        broker.publish('savedSearchRestored');
    }

    function _restoreFlightSearch(search) {
        searchUnitService.setOneWayFlightEnabled(TRPCONFIG.Domain.OneWayFlightsEnabled && search.OneWayOnly);
        searchUnitService.startDate(searchUnitService.flight, search.DepartureDate);
        searchUnitService.endDate(searchUnitService.flight, search.ReturnDate);
        searchUnitService.setDepartureAirports({
            Code: search.DepartureAirports.join(','),
            Title: search.DepartureAirportTitle
        });
        searchUnitService.setDestination(search.Destination);
        searchUnitService.setDestinationAirport({
            Code: search.DestinationAirports.join(','),
            Title: search.DestinationAirportTitle
        });
        return $q.when();
    }

    function _restoreHotelSearch(search) {
        searchUnitService.startDate(searchUnitService.hotel, search.CheckInDate);
        searchUnitService.endDate(searchUnitService.hotel, search.CheckOutDate);
        occupancyService.setOccupancy(search.Rooms);
        return searchUnitService.setDestination(search.Destination, false, true);
    }

    function _restoreHolidaySearch(search) {
        searchUnitService.startDate(searchUnitService.flight, search.DepartureDate);
        searchUnitService.endDate(searchUnitService.flight, search.ReturnDate);
        occupancyService.setOccupancy(search.Rooms);
        searchUnitService.setDepartureAirports({
            Code: search.DepartureAirports.join(','),
            Title: search.DepartureAirportsTitle
        });
        return searchUnitService.setDestination(search.Destination, false, true);
    }

    function _restoreTransferSearch(search) {
        searchUnitService.setDirection(search.Direction);
        searchUnitService.endDate(searchUnitService.transfer, search.ReturnDate || null);
        searchUnitService.startDate(searchUnitService.transfer, search.ArrivalDate || null);
        occupancyService.setOccupancy([search.Passengers]);
        searchUnitService.setDestinationAirport({
            Code: search.Airport,
            Title: search.AirportTitle
        });
        if (search.Route) {
            searchUnitService.setResort(search.Route.DropOffPoint);
        }
        return $q.when();
    }

    function _restoreParkingSearch(search) {
        searchUnitService.setDepartureAirports({ Code: search.AirportCode, Title: search.AirportTitle });
        occupancyService.setPassengerCount(search.Passengers);
        searchUnitService.startDate(searchUnitService.parking, search.DropOffDate);
        searchUnitService.endDate(searchUnitService.parking, search.PickUpDate);
        return $q.when();
    }

    function _restoreInsuranceSearch(search) {
        searchUnitService.startDate(searchUnitService.insurance, search.StartDate);
        searchUnitService.endDate(searchUnitService.insurance, search.EndDate);
        searchUnitService.setPolicyExtra(search.PolicyExtra);
        searchUnitService.setPolicyType(search.PolicyType);
        searchUnitService.setOccupancy(search.Passengers);
        searchUnitService.setTravelDestination(search.TravelDestination);
        return $q.when();
    }

    function saveFlightSearch(tripId, searchModel) {
        return _getFlightSearch(tripId, searchModel).then(flightSearch => _saveSearch(searchType.Flight, 'saveFlightSearch', () => flightSearch));
    }

    function saveHolidaySearch(tripId, searchModel) {
        return _getHolidaySearch(tripId, searchModel)
        .then(holidaySearch => _saveSearch(searchType.Holidays, 'saveholidaysearch', () => holidaySearch));
    }

    function saveHotelSearch(tripId) {
        //we don't want to record geo searches
        if (searchUnitService.getSearchArea()) {
            analytics.trackEvent({ category: 'searches', action: 'run', label: 'hotelgeosearch' });
            return;
        }
        return _getHotelSearch(tripId).then(hotelSearch => {
            let dest = _.get(hotelSearch, 'Destination', null);
            let checkInDate = new Date(_.get(hotelSearch, 'CheckInDate', '0001-01-01T00:00:00'));
            let checkOutDate = new Date(_.get(hotelSearch, 'CheckOutDate', '0001-01-01T00:00:00'));
            let rooms = _.get(hotelSearch, 'Rooms', null);
            let today = new Date();
            if (dest === null || checkOutDate.getTime() < today.getTime() || checkInDate.getTime() > checkOutDate.getTime() || rooms === null || searchType === null) {
                return;
            }
            return _saveSearch(searchType.Hotels, 'savehotelsearch', () => hotelSearch);
        });
    }

    function saveTransferSearch() {
        //PointToPointTransferSearch does not support Saved Search yet. OR-432 to implement this in the api.
        if (!TRPCONFIG.Domain.PointToPointTransferSearchEnabled) {
            _saveSearch(searchType.Transfers, 'savetransfersearch', _getTransferSearch);
        }
    }

    function saveParkingSearch(tripId) {
        _getParkingSearch(tripId).then(parkingSearch => _saveSearch(searchType.Parking, 'saveairportparkingsearch', () => parkingSearch));
    }

    function saveInsuranceSearch() {
        _saveSearch(searchType.Insurance, 'saveinsurancesearch', _getInsuranceSearch);
    }

    function restoreSearch(search) {
        switch (search.SearchType) {
            case searchType.Flight:
                return _restoreFlightSearch(search)
                    .then(_searchRestored);
            case searchType.Hotels:
                return _restoreHotelSearch(search)
                    .then(_searchRestored);
            case searchType.Holidays:
                return _restoreHolidaySearch(search)
                    .then(_searchRestored);
            case searchType.Transfers:
                return _restoreTransferSearch(search)
                    .then(_searchRestored);
            case searchType.Parking:
                return _restoreParkingSearch(search)
                    .then(_searchRestored);
            case searchType.Insurance:
                return _restoreInsuranceSearch(search)
                    .then(_searchRestored);
        }
        return $q.when(); //just in case
    }

    function getSavedSearches(searchTypes) {
        if (isPrerender) {
            return $q.when([]);
        }

        if (searchTypes) {
            // 'searchTypes' must be an array
            if (!_.isArray(searchTypes)) {
                searchTypes = [searchTypes];
            }
            // search types must be supported
            searchTypes = _.intersection(searchTypes, supportedSearchTypes);
        } else {
            // default to supported search types
            searchTypes = supportedSearchTypes;
        }

        if (cachedSearches == null || !_.isEqual(searchTypes.sort(), cachedSearchTypes.sort())) {
            // get searches from server
            cachedSearchTypes = searchTypes;
            cachedSearches = requestRecentSearches(searchTypes);
        }

        return cachedSearches.then(function(list) {
            //filter out any searches that are not valid because they are same day searches
            //and we are past the cut off time
            return arrayUtil.filter(list, function(s) {
                if (s.SearchType !== searchType.Hotels ||
                    (s.SearchType === searchType.Hotels &&
                    !hotelSearchValidator.validateTimeOfDay(s.CheckInDate))) {
                    return true;
                }
                service.removeSavedSearch(s.SavedSearchId);
                return false;
            });
        });

        function requestRecentSearches() {
            if (TRPCONFIG.Domain2.GetSaveSearchesAPI) {
                return $http.post(`${url}getsavedsearches`, { SearchTypes: searchTypes }, { ignoreErrors: true }).then(function(res) {
                    return res.data instanceof Array ? arrayUtil.map(res.data, _normaliseSearch) : [];
                });
            }
        }
    }

    function removeSavedSearch(id) {
        cachedSearches = null;
        return $http.post(`${url}removesavedsearch`, { SavedSearchId: id }).then(function() {
            broker.publish('savedSearchRemoved', id);
            return null;
        });
    }

    function getCabinType(idx) {
        return cabin[idx];
    }

    return service;
}
})();
